import React from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import PackageOne from "../../components/Combo-Packages/package-one";
import PackageSilver from "../../components/Combo-Packages/package-silver";
import PackageGold from "../../components/Combo-Packages/package-gold";
import PackagePromotional from "../../components/Combo-Packages/package-promotional";
import { Helmet } from "react-helmet";

function Package() {
  return (
    <>
      <Helmet>
        <title>Combo Packages – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Explore Innovatix Hub’s combo packages for affordable, tailored graphic design solutions in Hobart, TAS."
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta
          property="og:title"
          content="Combo Packages – Innovatix Hub Australia"
        />
        <meta
          property="og:description"
          content="Explore Innovatix Hub’s combo packages for affordable, tailored graphic design solutions in Hobart, TAS."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta
          property="og:url"
          content="https://innovatixhub.com.au/combo-packages"
        />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.webp"
        />

        <link
          rel="canonical"
          href="https://innovatixhub.com.au/combo-packages"
        />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="Combo Packages"
          subtitle={"Combo Packages"}
          className={"pt-175 pb-140"}
        />
        <PackageOne />
        <PackageSilver />
        <PackageGold />
        <PackagePromotional />
      </Layout>
    </>
  );
}

export default Package;
